export default __webpack_public_path__ + "static/media/IMDb_Logo_Square_Gold.9e54016c.png";